/* Progressive enhancement: catalog, links and content remain usable without JS. */
(() => {
  const initialized = new WeakSet();
  function init(root = document) {
    root.querySelectorAll('[data-ja-looks]').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const tabs = [...section.querySelectorAll('[data-ja-tab]')];
      const panels = [...section.querySelectorAll('[data-ja-panel]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].toggleAttribute('data-active', i === index);
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        });
      });
      section.querySelector('[data-ja-tabs]').hidden = false;
      section.dataset.jaReady = 'true';
      activate(0);
      section.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) activate(index);
      });
    });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.dataset.jaMotion !== 'true') return;
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ja-reveal');
        observer.unobserve(entry.target);
      });
    }, { threshold: .12 });
    root.querySelectorAll('.ja-edit .ja-product, .ja-discover-item, .ja-story-copy, .ja-section-head, .ja-faq details').forEach(el => observer.observe(el));
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ja-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.ja-menu[open]').forEach(menu => { if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false; });
  });
  const renderCount = count => {
    if (!Number.isInteger(count)) return;
    document.querySelectorAll('[data-ja-cart-count]').forEach(el => {
      el.textContent = String(count);
      const link = el.closest('a');
      if (link) link.setAttribute('aria-label', link.getAttribute('aria-label').replace(/\(\d+\)/, '(' + count + ')'));
    });
  };
  document.addEventListener('shopify:cart:lines-update', event => {
    event.promise?.then(({cart, detail}) => renderCount(cart?.totalQuantity ?? detail?.itemCount)).catch(() => {});
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'cart.js', {credentials:'same-origin'}).then(r => r.ok ? r.json() : null).then(cart => renderCount(cart?.item_count)).catch(() => {});
  });
})();
